<template>

    <section class="list-view row-center">
        <div class="contenedor-listado" :style="styles.backgroundWhite" :full="true">
            <div class="scroll-container">
                <h2 class="ficha-title" :style="styles.colorBasic">Utilidades</h2>

                <div class="contenedor-actillas row-center" v-if="!!brand.utilidades">
                    <a class="button actilla row-start" v-for="doc in brand.utilidades" :href="doc.url"
                        :style="styles.colorBasic" target="_blank" :title="doc.title">
                        <icon-download-doc></icon-download-doc>
                        <span v-html="doc.texto"></span>
                    </a>
                </div>

            </div>
        </div>
    </section>

</template>


<script>

    import { mapGetters } from 'vuex';
    import downloadDOC from '@/components/parts/icons/download-doc'

    export default {
        name: 'utilidades',
        computed: {
            ...mapGetters({
                styles: 'getStyles',
                colors: 'basicColors',
                brand: 'getBrand'
            }),
            ownstyle: function () {
                return {
                    ficha: {
                        'border-left': `10px solid ${this.colors.backgroundBody}`,
                        background: this.colors.white
                    },
                    vistaEncuesta: {
                        'border-left': `10px solid ${this.colors.backgroundBody}`,
                        background: this.colors.white
                    }
                }
            },
        },
        components: {
            'icon-download-doc': downloadDOC
        }

    }
</script>


<style lang="scss" scoped>
    .list-view {
        width: 100%;
        height: 100%;
        -webkit-flex-wrap: nowrap;
        -moz-flex-wrap: nowrap;
        -ms-flex-wrap: nowrap;
        -o-flex-wrap: nowrap;
        flex-wrap: nowrap;
        max-height: 100%;
        position: relative;

    }


    .contenedor-listado {
        width: 100%;
        height: 100%;
        display: inline-block;
        overflow: hidden;
        padding: 20px;

        &[showEncuesta=true] {
            width: auto;
        }
    }

    .contenedor-actillas{
        width: 100%;
        justify-content: flex-start;
        .button{
            padding: 10px;
            width:100%;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            border-bottom: 1px solid #9b9b9b;
            &:last-child{
                border-bottom: none;
            }

            &:hover{
                background: #f2f2f2;
            }
            svg{
                max-width: 30px;
                margin-right: 15px;
            }
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/views/utilidades.vue